import "./style.less";
// eslint-disable-next-line no-unused-vars
import iconCurrency from "./assets/icon-currency.svg";
// eslint-disable-next-line no-unused-vars
import iconActivity from "./assets/icon-activity.svg";

export default function LaneAccordian() {
    return {
        restrict: "E",
        scope: {
            lane: "<",
        },
        template: require("./template.html"),

        controller: function ($scope, houseService) {
            $scope.getInfo = (lane) => {
                if (!lane.isOpen) return false;
                if (!lane.info) {
                    const aOfHouseIds = [lane.LaneID];
                    houseService.getHousesInline(aOfHouseIds).then((res) => {
                        lane.info = res[0];

                        focusAccBody(lane.LaneID);
                    });
                }

                focusAccBody(lane.LaneID);
            };

            const focusAccBody = (LaneID) => {
                $("#lane-" + LaneID + " .accordian-body").focus();
            };
        },
    };
}
